document.addEventListener('DOMContentLoaded', function() {
  const ensurePopupVideo = (popup) => {
    if (!popup) return null;

    let video = popup.querySelector('video');
    if (video) return video;

    const videoSrc = popup.dataset.videoSrc;
    if (!videoSrc) return null;

    video = document.createElement('video');
    video.className = 'pvideo_video';
    video.controls = true;
    video.playsInline = true;
    video.preload = 'metadata';

    if (popup.dataset.videoPoster) {
      video.poster = popup.dataset.videoPoster;
    }

    const source = document.createElement('source');
    source.src = videoSrc;
    source.type = 'video/mp4';
    video.appendChild(source);

    popup.innerHTML = '';
    popup.appendChild(video);

    return video;
  };

  const closePopupVideo = (parent) => {
    if (!parent) return;

    const activePopup = parent.querySelector('.ppopup_show');
    const activeVideo = activePopup ? activePopup.querySelector('video') : null;
    if (activeVideo) {
      activeVideo.pause();
    }

    document.querySelectorAll('.pvideo_popup').forEach(el => {
      el.classList.remove('ppopup_show');
      el.innerHTML = '<div class="pvideo_video_placeholder"></div>';
    });

    parent.classList.remove('video_popups_show');
  };

  document.addEventListener('click', (e) => {
    const bundle_item = e.target.closest('.lineitem_bundle_item');
    if (bundle_item) {
      const qty = bundle_item.getAttribute('data_qty');
      const parent = bundle_item.closest('.line-item');
      const qty_input = parent.querySelector('.quantity-selector__input');

      if (qty_input) {
        qty_input.value = parseInt(qty);
        qty_input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    //---------------- Start - Produktbilder testen ----------------

    const pvideos_toggle = e.target.closest('.pvideos_toggle');
    if (pvideos_toggle) {
      const pvideos_wrapper = document.querySelector('.pvideos_list_wrapper');
      if (pvideos_wrapper) {
        pvideos_wrapper.classList.toggle('pvideos_wrapper_active');
      }
    }
    const pvideo_item = e.target.closest('.pvideo_item');
    if(pvideo_item){
      const popup_id = pvideo_item.getAttribute('popup');
      const popup = document.querySelector(`.pvideo_popup[popup="${popup_id}"]`);
      if(popup){
        const parent = popup.closest('.video_popups_main');
        parent.classList.add('video_popups_show');
        popup.classList.add('ppopup_show');
        const video = ensurePopupVideo(popup);
        if (video) {
          video.play();
        }
      }
    }
    const video_overlay = e.target.closest('.video_popup_overlay');
    if(video_overlay){
      const parent = video_overlay.closest('.video_popups_main');
      closePopupVideo(parent);
    }
    const video__close = e.target.closest('.video_popup_close');
    if(video__close){
      const parent = video__close.closest('.video_popups_main');
      closePopupVideo(parent);
    }  
    //---------------- End - Produktbilder testen ----------------

  });
});


document.addEventListener('click', function(event) {
  const free_gift_btn = event.target.closest('.fgi-atc-btn');
  if (!free_gift_btn) return;

  const gift_id = parseInt(free_gift_btn.getAttribute('data-id'));
  if (!gift_id) return;

  free_gift_btn.setAttribute('disabled', true);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: gift_id,
          quantity: 1,
          properties:{
            free_gift_item:true
          }
        }
      ]
    })
  })
  .then(res => res.json())
  .then(cartData => {
    free_gift_btn.removeAttribute('disabled');
    fetch('/cart.js', {
      credentials: "same-origin",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(response => response.json())
    .then(data => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart: data, openMiniCart: true, replacementDelay: 0 }
          })
        );
    });
  })
  .catch(err => {
    free_gift_btn.removeAttribute('disabled');
    console.error("❌ Error adding bundle:", err);
  });
});

document.addEventListener('cart:refresh', function(event) {
  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const freegift_count = parseInt(mini_drawer.getAttribute('data-freegift-count'));

  const freeGiftItems = cart.items.filter(item => 
    item.properties && item.properties.free_gift_item
  );

  if (!freeGiftItems.length) return;

  if (cart.item_count < freegift_count) {

    const updates = {};

    freeGiftItems.forEach(item => {
      updates[item.key] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
    .then(res => res.json())
    .then(updatedCart => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart,
            openMiniCart: true,
            replacementDelay: 0
          }
        })
      );
    })
    .catch(err => console.error('Free gift remove error:', err));
  }
});


// -------------------- New Variant Design --------------------

document.addEventListener('DOMContentLoaded', function () {

  const wrapper = document.querySelector('.pdp_free_gift');
  if (!wrapper) return;

  const toggle = wrapper.querySelector('.pdp_free_gift_toggle');
  const form = document.querySelector('.product-form__buy-buttons form');

  if (!toggle || !form) return;

  toggle.addEventListener('change', function () {
    const existingInputs = form.querySelectorAll('.free_gift_select');

    if (this.checked) {
      if (existingInputs.length) return;

      const variantId = wrapper.dataset.variantId;
      const productId = wrapper.dataset.productId;
      
      // ID input
      const idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.value = variantId;
      idInput.classList.add('free_gift_select');
      idInput.setAttribute('data-free-gift-variant-id', 'true');

      // Property input
      const propInput = document.createElement('input');
      propInput.type = 'hidden';
      propInput.value = productId;
      propInput.classList.add('free_gift_select');
      propInput.setAttribute('data-free-gift-product-id', 'true');

      form.appendChild(idInput);
      form.appendChild(propInput);

    } else {
      existingInputs.forEach(el => el.remove());
    }

  });

});

function freeShippingToggle(qty){
  const fg_wrapper = document.querySelector('.pdp_free_gift');
  const mn_drawer = document.querySelector('#mini-cart');
  const threshold = mn_drawer.getAttribute('minimum_qty');
  const fg_toggle = document.querySelector('.pdp_free_gift_toggle');
  if (fg_toggle) {
    if (qty >= threshold) {
      fg_wrapper.classList.add('fg_wrapper_active');
    } else {
      fg_wrapper.classList.remove('fg_wrapper_active');
      fg_toggle.checked = false;
      fg_toggle.dispatchEvent(new Event('change'));
    }
  }
}


let isUpdatingFreeGift = false;

document.addEventListener('cart:refresh', function(event) {
  if (isUpdatingFreeGift) return;

  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const minimum_qty = parseInt(mini_drawer.getAttribute('minimum_qty') || 0);

  const freeGiftItems = cart.items.filter(item => item.properties && item.properties.free_gift_id);

  freeGiftItems.forEach((freeGiftItem) => {
    const targetProductId = freeGiftItem.properties.free_gift_id;

    const parentQty = cart.items
      .filter(item => item.product_id == targetProductId)
      .reduce((sum, item) => sum + item.quantity, 0);

    if (parentQty < minimum_qty) {
      isUpdatingFreeGift = true;
      updateFreeGift(freeGiftItem.variant_id, 0);
      return;
    }

    if (freeGiftItem.quantity > 1) {
      isUpdatingFreeGift = true;
      updateFreeGift(freeGiftItem.variant_id, 1);
      return;
    }
  });
});

function updateFreeGift(variantId, qty) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      updates: {
        [variantId]: qty
      }
    })
  })
  .then(res => res.json())
  .then(updatedCart => {
    isUpdatingFreeGift = false;

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: updatedCart,
          openMiniCart: true,
          replacementDelay: 0
        }
      })
    );
  })
  .catch(err => {
    isUpdatingFreeGift = false;
    console.error('Free gift update error:', err);
  });
}

// -------------------- New Variant Design --------------------

// ---------------- Product Hotspots ----------------
(function () {
  const ROOT_SELECTOR = '[data-product-hotspots-root]';

  function initProductHotspots(scope = document) {
    const roots = scope.querySelectorAll(`${ROOT_SELECTOR}:not([data-hotspots-initialized])`);

    roots.forEach((root) => {
      root.setAttribute('data-hotspots-initialized', 'true');

      const productMedia = root.closest('product-media, .product__media');
      const mediaList = productMedia ? productMedia.querySelector('.product__media-list') : null;
      const flickityCarousel = productMedia ? productMedia.querySelector('flickity-carousel') : null;
      const modal = root.querySelector('[data-product-hotspot-modal]');
      const panels = Array.from(root.querySelectorAll('[data-hotspot-panel]'));
      let pagination = modal ? modal.querySelector('.product-hotspot-modal__pagination') : null;

      if (modal && panels.length > 1 && !pagination) {
        const dialog = modal.querySelector('.product-hotspot-modal__dialog');
        pagination = document.createElement('div');
        pagination.className = 'product-hotspot-modal__pagination';
        pagination.setAttribute('aria-label', 'Hotspot auswählen');

        panels.forEach((panel, panelIndex) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-hotspot-modal__pagination-dot';
          dot.setAttribute('data-hotspot-pagination-dot', String(panelIndex));
          dot.setAttribute('aria-label', `Hotspot ${panelIndex + 1} anzeigen`);
          if (panelIndex === 0) dot.setAttribute('aria-current', 'true');
          pagination.appendChild(dot);
        });

        if (dialog) dialog.appendChild(pagination);
      }

      const eligibleMediaIds = new Set(
        (root.dataset.eligibleMediaIds || '')
          .split(',')
          .map((id) => id.trim())
          .filter(Boolean)
      );

      let activeIndex = 0;
      let syncQueued = false;
      let lastActiveMediaId = '';
      let hotspotTransitionTimer = null;
      let hotspotTransitionToken = 0;
      let transitionPreviousWasEligible = false;

      const HOTSPOT_TO_HOTSPOT_REVEAL_DELAY = 20;
      const NON_HOTSPOT_TO_HOTSPOT_REVEAL_DELAY = 80;

      const getActiveMediaItem = () => {
        if (!productMedia) return null;

        const selectedItem = productMedia.querySelector('.product__media-item.is-selected:not(.is-filtered)');
        if (selectedItem) return selectedItem;

        const currentThumb = productMedia.querySelector('[data-media-id][aria-current="true"]');
        if (currentThumb && currentThumb.dataset.mediaId) {
          return productMedia.querySelector(`.product__media-item[data-media-id="${currentThumb.dataset.mediaId}"]:not(.is-filtered)`);
        }

        const initialItem = productMedia.querySelector('.product__media-item.is-initial-selected:not(.is-filtered)');
        if (initialItem) return initialItem;

        return null;
      };

      const revealHotspotsAfterActiveMediaReady = (delay = 30) => {
        const token = ++hotspotTransitionToken;

        if (hotspotTransitionTimer) {
          window.clearTimeout(hotspotTransitionTimer);
        }

        const reveal = () => {
          if (token !== hotspotTransitionToken) return;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              if (token !== hotspotTransitionToken) return;

              hotspotTransitionTimer = window.setTimeout(() => {
                if (token !== hotspotTransitionToken) return;
                syncVisibility();
                root.classList.remove('is-transitioning');
              }, delay);
            });
          });
        };

        const activeItem = getActiveMediaItem();
        const activeImage = activeItem ? activeItem.querySelector('img') : null;

        if (activeImage && !activeImage.complete) {
          const fallbackTimer = window.setTimeout(reveal, 1200);
          const onReady = () => {
            window.clearTimeout(fallbackTimer);
            reveal();
          };

          activeImage.addEventListener('load', onReady, { once: true });
          activeImage.addEventListener('error', onReady, { once: true });
        } else {
          reveal();
        }
      };

      const beginHotspotMediaTransition = (fallbackDelay = 1400) => {
        // Store the state at the beginning of the transition only once.
        // This matters for non-hotspot -> hotspot swipes: MutationObserver may
        // mark the new media as eligible before Flickity has visually settled,
        // but we still want the longer reveal delay for that transition.
        if (!root.classList.contains('is-transitioning')) {
          transitionPreviousWasEligible = root.classList.contains('is-visible');
        }

        ++hotspotTransitionToken;
        root.classList.add('is-transitioning');

        if (hotspotTransitionTimer) {
          window.clearTimeout(hotspotTransitionTimer);
        }

        // Safety fallback only. The normal reveal is handled by Flickity's
        // flickity:slide-settled event, so hotspots do not come back while
        // the image is still swiping into place.
        hotspotTransitionTimer = window.setTimeout(() => {
          finishHotspotMediaTransition();
        }, fallbackDelay);
      };

      const finishHotspotMediaTransition = (customDelay = null) => {
        const activeItem = getActiveMediaItem();
        const activeMediaId = activeItem && activeItem.dataset.mediaId ? activeItem.dataset.mediaId : '';
        const nextIsEligible = eligibleMediaIds.has(activeMediaId);

        if (!nextIsEligible) {
          if (hotspotTransitionTimer) {
            window.clearTimeout(hotspotTransitionTimer);
            hotspotTransitionTimer = null;
          }

          ++hotspotTransitionToken;
          root.classList.remove('is-visible');
          root.classList.remove('is-transitioning');
          lastActiveMediaId = activeMediaId;
          return;
        }

        const revealDelay = customDelay !== null
          ? customDelay
          : (transitionPreviousWasEligible ? HOTSPOT_TO_HOTSPOT_REVEAL_DELAY : NON_HOTSPOT_TO_HOTSPOT_REVEAL_DELAY);

        revealHotspotsAfterActiveMediaReady(revealDelay);
      };

      const getActiveMediaId = () => {
        const activeItem = getActiveMediaItem();
        return activeItem && activeItem.dataset.mediaId ? activeItem.dataset.mediaId : '';
      };

      const syncVisibility = () => {
        syncQueued = false;
        const activeMediaId = getActiveMediaId();
        const shouldShow = eligibleMediaIds.has(activeMediaId);
        root.classList.toggle('is-visible', shouldShow);
        if (!shouldShow) {
          root.classList.remove('is-transitioning');
        }
        lastActiveMediaId = activeMediaId;
      };

      const queueSync = () => {
        if (syncQueued) return;
        syncQueued = true;
        window.requestAnimationFrame(syncVisibility);
      };

      const pauseAllVideos = () => {
        root.querySelectorAll('video').forEach((video) => {
          video.pause();
        });
      };

      const playPanelVideo = (panel) => {
        if (!panel) return;

        const video = panel.querySelector('video');
        if (!video) return;

        try {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
              // Some browsers still block autoplay with sound. In that case the controls remain visible.
            });
          }
        } catch (error) {
          // Keep the modal usable even if autoplay is blocked.
        }
      };

      const updatePagination = () => {
        if (!pagination) return;

        pagination.querySelectorAll('[data-hotspot-pagination-dot]').forEach((dot) => {
          const dotIndex = parseInt(dot.dataset.hotspotPaginationDot, 10);
          if (dotIndex === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const ensurePanelVideo = (panel) => {
        if (!panel) return;

        const holder = panel.querySelector('[data-hotspot-video-holder]');
        if (!holder) return;

        const existingVideo = holder.querySelector('video');
        if (existingVideo) return existingVideo;

        const videoSrc = holder.dataset.videoSrc;
        if (!videoSrc) return;

        const video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.autoplay = true;
        video.loop = true;
        video.setAttribute('loop', '');
        video.preload = 'metadata';
        video.className = 'product-hotspot-modal__video';

        if (holder.dataset.videoPoster) {
          video.poster = holder.dataset.videoPoster;
        }

        const source = document.createElement('source');
        source.src = videoSrc;
        source.type = 'video/mp4';
        video.appendChild(source);

        holder.innerHTML = '';
        holder.appendChild(video);

        return video;
      };

      const showPanel = (index, shouldAutoplay = false) => {
        if (!panels.length) return;

        activeIndex = ((index % panels.length) + panels.length) % panels.length;

        panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === activeIndex;
          panel.hidden = !isActive;
          panel.classList.toggle('is-active', isActive);
        });

        updatePagination();
        pauseAllVideos();
        ensurePanelVideo(panels[activeIndex]);

        if (shouldAutoplay || (modal && modal.classList.contains('is-active'))) {
          playPanelVideo(panels[activeIndex]);
        }
      };

      const openModal = (index) => {
        if (!modal) return;

        showPanel(index, false);
        modal.classList.add('is-active');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product-hotspot-modal-open');
        playPanelVideo(panels[activeIndex]);

        const dialog = modal.querySelector('.product-hotspot-modal__dialog');
        if (dialog) dialog.focus({ preventScroll: true });
      };

      const closeModal = () => {
        if (!modal) return;

        pauseAllVideos();
        modal.classList.remove('is-active');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('product-hotspot-modal-open');
      };

      root.addEventListener('click', (event) => {
        const openButton = event.target.closest('[data-hotspot-open]');
        if (openButton) {
          event.preventDefault();
          event.stopPropagation();
          openModal(parseInt(openButton.dataset.hotspotOpen, 10) || 0);
          return;
        }

        if (event.target.closest('[data-hotspot-close]')) {
          event.preventDefault();
          closeModal();
          return;
        }

        const paginationDot = event.target.closest('[data-hotspot-pagination-dot]');
        if (paginationDot) {
          event.preventDefault();
          showPanel(parseInt(paginationDot.dataset.hotspotPaginationDot, 10) || 0);
          return;
        }

        if (event.target.closest('[data-hotspot-prev]')) {
          event.preventDefault();
          showPanel(activeIndex - 1);
          return;
        }

        if (event.target.closest('[data-hotspot-next]')) {
          event.preventDefault();
          showPanel(activeIndex + 1);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (!modal || !modal.classList.contains('is-active')) return;

        if (event.key === 'Escape') {
          closeModal();
        } else if (event.key === 'ArrowLeft') {
          showPanel(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          showPanel(activeIndex + 1);
        }
      });

      if (productMedia) {
        ['pointerdown', 'touchstart', 'mousedown'].forEach((eventName) => {
          productMedia.addEventListener(eventName, () => {
            beginHotspotMediaTransition(220);
          }, { passive: true, capture: true });
        });

        // Deliberately do NOT reveal hotspots on pointerup/touchend/click.
        // On Flickity galleries those happen before the slide has visually settled,
        // which is what made the hotspots appear too early.
        productMedia.addEventListener('click', () => {
          beginHotspotMediaTransition(220);
          queueSync();
        }, true);
      }

      if (flickityCarousel) {
        flickityCarousel.addEventListener('flickity:slide-changed', () => {
          beginHotspotMediaTransition(220);
          queueSync();
        });

        flickityCarousel.addEventListener('flickity:slide-settled', () => {
          finishHotspotMediaTransition();
        });

        flickityCarousel.addEventListener('flickity:ready', () => {
          queueSync();
        });
      }

      if (mediaList && window.MutationObserver) {
        const observer = new MutationObserver(() => {
          const activeMediaId = getActiveMediaId();
          if (activeMediaId && lastActiveMediaId && activeMediaId !== lastActiveMediaId) {
            beginHotspotMediaTransition(220);
          }
          queueSync();
        });
        observer.observe(mediaList, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'aria-current']
        });
      }

      ['variant:changed', 'product:variant-change', 'product:media-change', 'media:changed'].forEach((eventName) => {
        document.addEventListener(eventName, () => {
          beginHotspotMediaTransition(220);
          queueSync();
          // Fallback for non-Flickity-triggered variant changes. Flickity's
          // slide-settled event will normally reveal them earlier and cleaner.
          window.setTimeout(() => finishHotspotMediaTransition(), 220);
        });
      });

      syncVisibility();
      window.setTimeout(syncVisibility, 500);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductHotspots(document));

  document.addEventListener('shopify:section:load', (event) => {
    initProductHotspots(event.target);
  });
})();

// --- Product hotspot coordinate stage fix ---
// Keeps hotspot coordinates locked to the active visible product image while resizing.
(function () {
  const ROOT_SELECTOR = '[data-product-hotspots-root]';
  const SYNC_ATTR = 'data-hotspot-stage-sync-initialized';

  function getProductMedia(root) {
    return root.closest('product-media, .product__media');
  }

  function getActiveMediaItem(productMedia) {
    if (!productMedia) return null;

    return (
      productMedia.querySelector('.product__media-item.is-selected:not(.is-filtered)') ||
      productMedia.querySelector('.product__media-item.is-initial-selected:not(.is-filtered)') ||
      productMedia.querySelector('.product__media-item:not(.is-filtered)')
    );
  }

  function getStageElement(mediaItem) {
    if (!mediaItem) return null;

    return (
      mediaItem.querySelector('.product__media-image-wrapper') ||
      mediaItem.querySelector('.aspect-ratio') ||
      mediaItem.querySelector('img, video, model-viewer') ||
      mediaItem
    );
  }

  function syncRoot(root) {
    if (!root || !root.isConnected) return;

    const productMedia = getProductMedia(root);
    const mediaItem = getActiveMediaItem(productMedia);
    const stage = getStageElement(mediaItem);

    if (!stage) {
      root.style.setProperty('--hotspot-stage-left', '0px');
      root.style.setProperty('--hotspot-stage-top', '0px');
      root.style.setProperty('--hotspot-stage-width', '100%');
      root.style.setProperty('--hotspot-stage-height', '100%');
      return;
    }

    const rootRect = root.getBoundingClientRect();
    const stageRect = stage.getBoundingClientRect();

    if (!rootRect.width || !rootRect.height || !stageRect.width || !stageRect.height) return;

    root.style.setProperty('--hotspot-stage-left', `${stageRect.left - rootRect.left}px`);
    root.style.setProperty('--hotspot-stage-top', `${stageRect.top - rootRect.top}px`);
    root.style.setProperty('--hotspot-stage-width', `${stageRect.width}px`);
    root.style.setProperty('--hotspot-stage-height', `${stageRect.height}px`);
  }

  let syncQueued = false;

  function syncAll() {
    syncQueued = false;
    document.querySelectorAll(ROOT_SELECTOR).forEach(syncRoot);
  }

  function queueSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(syncAll);
  }

  function initHotspotStageSync(scope = document) {
    const roots = scope.querySelectorAll(`${ROOT_SELECTOR}:not([${SYNC_ATTR}])`);

    roots.forEach((root) => {
      root.setAttribute(SYNC_ATTR, 'true');

      const productMedia = getProductMedia(root);
      const mediaList = productMedia ? productMedia.querySelector('.product__media-list') : null;

      if (productMedia) {
        productMedia.addEventListener('click', () => {
          queueSync();
          window.setTimeout(queueSync, 80);
          window.setTimeout(queueSync, 260);
        }, true);
      }

      if (mediaList && window.MutationObserver) {
        const observer = new MutationObserver(queueSync);
        observer.observe(mediaList, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'aria-current']
        });
      }

      root.querySelectorAll('img, video').forEach((media) => {
        media.addEventListener('load', queueSync);
        media.addEventListener('loadedmetadata', queueSync);
      });

      syncRoot(root);
      window.setTimeout(() => syncRoot(root), 200);
      window.setTimeout(() => syncRoot(root), 800);
    });
  }

  ['variant:changed', 'product:variant-change', 'product:media-change', 'media:changed'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      queueSync();
      window.setTimeout(queueSync, 100);
      window.setTimeout(queueSync, 350);
    });
  });

  window.addEventListener('resize', queueSync, { passive: true });
  window.addEventListener('orientationchange', () => {
    queueSync();
    window.setTimeout(queueSync, 300);
  });
  window.addEventListener('load', queueSync);

  document.addEventListener('DOMContentLoaded', () => {
    initHotspotStageSync(document);
    queueSync();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initHotspotStageSync(event.target);
    queueSync();
  });
})();
